<!--
  The sidebar is the whole chrome. There is no top bar on a desktop dashboard, so the two things
  the header used to hold — the brand and the profile — live here, at either end of the nav.

  That is why it is a <header>, the page's banner landmark, and not an <aside>: it carries exactly
  what the design system's header carries on every other screen (brand, the way into the nav, the
  account), so every route with chrome exposes one banner, whichever shape it is drawn in. It sits
  outside <main> in the app shell, so the banner role is not scoped away.
-->
<header class="dashboard-aside">
  <!-- The terrain in the wood. Decorative, and it sits under everything the sidebar says. -->
  <canvas aria-hidden="true" class="dashboard-sidemap" [appContourMap]="sideMap"></canvas>

  <a aria-label="AnotherTrip — dashboard" class="dashboard-brand" routerLink="/dashboard">
    <img alt="" class="dashboard-brand__logo" height="32" src="assets/icons/logo-at-light.svg" width="137" />
  </a>

  <div class="dashboard-nav-host">
    <app-dashboard-nav />
  </div>

  <div class="dashboard-profile">
    <app-sidebar-footer />
  </div>
</header>
